import { useAuth } from "../Contexts/AuthContext";
import { useRef } from "react";

const TwoFactorModalLogin = ({ handleLogin, confirmMode, confirm,blocked}) => {
    const { twoFaOpen, wrongCode, tokenRefs, setTwofa } = useAuth();

    const handleInputChange = (index, event) => {
        const value = event.target.value;

        // Se o valor for um dígito, mova para o próximo input
        if (value.match(/^[0-9]$/)) {
            if (index < tokenRefs.current.length - 1) {
                tokenRefs.current[index + 1].focus();
            }
        }

        // Se o valor for vazio, mova para o input anterior
        if (value === '' && index > 0) {
            tokenRefs.current[index - 1].focus();
        }
    };

    const handleKeyDown = (index, event) => {
        // Permitir apenas números e a tecla Backspace
        if (event.key === 'Backspace' && event.target.value === '' && index > 0) {
            tokenRefs.current[index - 1].focus();
        }
    };

    return (
        <div className={`${twoFaOpen ? '' : 'hidden'} ${confirm ? 'md:left-[30%]' : ''}  text-white absolute md:w-[400px] flex px-8 flex-col gap-3 pt-3 p-4 rounded-[10px] bg-[#1D1D1D]`}>
            <div className="relative">
                <svg onClick={()=>{setTwofa(false)}} className="z-[99999] cursor-pointer absolute right-[-10px] top-[10px]" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M11.7017 10.8615C11.7568 10.9167 11.8006 10.9822 11.8304 11.0542C11.8603 11.1263 11.8757 11.2036 11.8757 11.2816C11.8757 11.3596 11.8603 11.4368 11.8304 11.5089C11.8006 11.581 11.7568 11.6465 11.7017 11.7017C11.6465 11.7568 11.581 11.8006 11.5089 11.8304C11.4368 11.8603 11.3596 11.8757 11.2816 11.8757C11.2036 11.8757 11.1263 11.8603 11.0542 11.8304C10.9822 11.8006 10.9167 11.7568 10.8615 11.7017L5.93783 6.77724L1.01416 11.7017C0.902747 11.8131 0.75164 11.8757 0.59408 11.8757C0.43652 11.8757 0.285414 11.8131 0.174002 11.7017C0.0625904 11.5902 3.10588e-09 11.4391 0 11.2816C-3.10588e-09 11.124 0.0625904 10.9729 0.174002 10.8615L5.09842 5.93783L0.174002 1.01416C0.0625904 0.902747 0 0.75164 0 0.59408C0 0.43652 0.0625904 0.285414 0.174002 0.174002C0.285414 0.0625904 0.43652 0 0.59408 0C0.75164 0 0.902747 0.0625904 1.01416 0.174002L5.93783 5.09842L10.8615 0.174002C10.9729 0.0625904 11.124 -3.10588e-09 11.2816 0C11.4391 3.10588e-09 11.5902 0.0625904 11.7017 0.174002C11.8131 0.285414 11.8757 0.43652 11.8757 0.59408C11.8757 0.75164 11.8131 0.902747 11.7017 1.01416L6.77724 5.93783L11.7017 10.8615Z" fill="white" />
                </svg>
                <h1>Autenticação de 2 fatores</h1>
                <p className="text-[10px]">Insira o código do aplicativo autenticador</p>
                <p className={`text-[10px] ${wrongCode && !blocked ? '' : 'hidden'} mt-2 text-[red]`}>Código inválido</p>
                <p className={`text-[10px] ${blocked ? '' : 'hidden'} mt-2 text-[red]`}>Conta Bloqueada</p>
            </div>
            <div className="flex relative z-[99999] gap-3 justify-between">
                {Array.from({ length: 6 }).map((_, index) => (
                    <input
                        key={index}
                        ref={el => tokenRefs.current[index] = el}
                        type="text"
                        maxLength="1"
                        className="w-[40px] h-[40px] text-center border-b-2 border-[#343B4F] bg-transparent text-white focus:outline-none"
                        onChange={(e) => handleInputChange(index, e)}
                        onKeyDown={(e) => handleKeyDown(index, e)}
                    />
                ))}
            </div>
            {!confirmMode && <button className='bg-[#478DF8] relative z-[99999] rounded-[10px] w-full p-1 text-white' onClick={handleLogin}>Confirmar</button>}
            {confirmMode && <button className='bg-[#478DF8] rounded-[10px] w-full p-1 text-white relative z-[99999]' onClick={confirm}>Confirmar</button>}
            <p className={`text-[10px] mt-2 text-[red]`}>Nunca compartilhe esse código com ninguém</p>
        </div>
    );
};

export default TwoFactorModalLogin;